import React, { Component } from 'react';
import Layout from '../../../Layouts/DefaultLayout';
import { PartnersBMOGrid } from '../../../Components';
import { Breadcrumb } from 'react-bootstrap'


class ResourceBmosViewContainer extends Component {

    constructor(props) {
        super();
        this.state = {
            regions: [],
            region_countries: [],
            countries: []
        }
        document.title = "Bridge Alliance | 5G Resources"
    }

    componentWillMount = async () => {
        await this.props.setGeneralData();
        if (this.props.countries.length > 0) {
            this.props.setRegionData(this.props.countries);
        }
    }
    componentDidMount = async () => {
        this._setData(1);
    }


    shouldComponentUpdate(nextProps, nextState) {

        return true;
    }

    onPageChange = (pageno) => {
        this._setData(pageno);
    }

    _setData = async (page) => {
        let formdata = {
            "posts_per_page": 1000
        }
        if (this.state.regions.length > 0) {
            formdata["regions"] = this.state.regions;
        } if (this.state.region_countries.length > 0) {
            formdata["regions-countries"] = this.state.region_countries;
        } if (this.state.countries.length > 0) {
            formdata["countries"] = this.state.countries;
        }

        await this.props.searchBMOSJson(
            this.props.token, page, formdata
        );
    }

    _convertSelectedDataToArray = (e) => {
        let ar = [];
        e.forEach(function (element) {
            ar.push(element.value);
        });
        return ar;
    }
    _onChangeSelect = (e, type) => {
        this.setState({ [type]: e }, () => {
            this._setData(1)
        });
    }


    render = () => {
        return (
            <Layout>
                <div className="container">
                        {/*<Breadcrumb className="mt-4">
                            <Breadcrumb.Item href="/operators">Operators</Breadcrumb.Item>
                        </Breadcrumb>*/}
                        <h1>5G Resources</h1>
                        <PartnersBMOGrid
                            regions={this.props.regions}
                            countries={this.props.countries}
                            data={this.props.data.result}
                            selectedData={this.props.data.selected || {}}
                            onChange={this._onChangeSelect}
                            currentpage={parseInt(this.props.data.currentpage)}
                            max_num_pages={parseInt(this.props.data.max_num_pages)}
                            isLoading={this.props.isLoading_bmos}
                            perslot={6}
                            onPageChange={this.onPageChange}
                        />
                 
                </div>
            </Layout>
        );
    };



}


/* Export Component ==================================================================== */
export default ResourceBmosViewContainer;